module.exports = __webpack_public_path__ + "img/serve-notice-bg.c75a8d76.png";